import { ref } from 'vue'

const messages = ref([])
const conversations = ref([])
const currentConversationId = ref(null)
const isLoading = ref(false)
const isStreaming = ref(false)
const currentThinkingSteps = ref([])
const currentStreamController = ref(null)
const inFlightConversationKey = ref(null)
const messagesByConversationKey = ref({})
const selectedListsByConversationId = ref({})

export const useAiChatState = () => ({
    messages,
    conversations,
    currentConversationId,
    isLoading,
    isStreaming,
    currentThinkingSteps,
    currentStreamController,
    inFlightConversationKey,
    messagesByConversationKey,
    selectedListsByConversationId,
})
